import { Inject, Injectable, Provider, inject } from '@angular/core';
import { ApiService } from './api.service';
import { Subject } from 'rxjs';
import { SnackbarService } from './snackbar.service';
import { ApiSentrynelService } from './api-sentrynel.service';

@Injectable({
  providedIn: 'root'
})
export class CrudSentrynelService<T> {

  constructor(
    @Inject('endpoint') protected endpoint: string,
    @Inject(ApiSentrynelService) protected readonly api: ApiSentrynelService,
    @Inject(SnackbarService) protected readonly snackbar: SnackbarService
  ) { }

  read(id: number | string) {
    let model: Subject<T> = new Subject<T>();
    this.api.get<T>(`${this.endpoint}/${id}`).subscribe((value) => {
      model.next(value)
    });
    return model.asObservable();
  }

  save(model: any, id?: number | string) {
    let saved: Subject<T> = new Subject<T>();
    let url = this.endpoint;
    if (id) {
      url += `/${id}`;
      this.api.put<T>(url, model).subscribe({
        next: value => saved.next(value),
        complete: () => this.snackbar.success('Dati salvati con successo!')
      });
    } else {
      this.api.post<T>(url, model).subscribe({
        next: value => saved.next(value),
        complete: () => {
          this.snackbar.success('Dati salvati con successo!');
        }
      });
    }
    return saved.asObservable();
  }

  delete(id: number | string) {
    let deleted: Subject<any> = new Subject<any>();
    this.api.delete(`${this.endpoint}/${id}`).subscribe({
      next: (value) => {
        deleted.next(value);
      },
      complete: () => this.snackbar.success('Dati eliminati con successo!')
    })
    
    return deleted;
  }

}

export function provideCrudService<T>(
  endpoint: string,
): Provider[] {
  return [
    {
      provide: createTokenCrudServiceInstance(endpoint),
      useFactory: () => new CrudSentrynelService<T>(
        endpoint,
        inject(ApiSentrynelService),
        inject(SnackbarService))
    }
  ]
}

export function createTokenCrudServiceInstance(endpoint: string) {
  return `${endpoint}-crud-service`;
}
